(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  // Fix mobile drawer menu links by injecting "All [Category]" at the BOTTOM of submenus
  var drawerLinkMap = {
    'за плаж': { url: '/collections/за-плаж', label: 'Всичко за плаж' },
    'за дома': { url: '/collections/за-дома-всички', label: 'Всичко за дома' },
    'комплекти': { url: '/collections/комплекти', label: 'Всички комплекти' },
    'ново': { url: '/collections/ново', label: 'Всичко ново' },
    'за нас': { url: '/pages/about-us', label: 'Всичко за нас' }
  };

  function injectMobileMenuLinks() {
    var container = document.querySelector('#menu-drawer') || document.querySelector('.menu-drawer-container') || document;
    var listItems = container.querySelectorAll('li');
    if (!listItems.length) return;

    listItems.forEach(function(li) {
      // Find direct child UL if it exists; sometimes deeply nested depending on theme
      var childUl = li.querySelector('ul');
      if (!childUl) return; 

      if (li.dataset.injectedAllLinkProcessed) return;

      // Clone node to safely extract text without pulling in submenu labels
      var clone = li.cloneNode(true);
      var subUls = clone.querySelectorAll('ul');
      subUls.forEach(function(ul) { ul.remove(); });
      
      var rawText = clone.textContent.trim().toLowerCase();
      var mapData = null;

      if (rawText.indexOf('за плаж') !== -1) mapData = drawerLinkMap['за плаж'];
      else if (rawText.indexOf('за дома') !== -1) mapData = drawerLinkMap['за дома'];
      else if (rawText.indexOf('комплекти') !== -1) mapData = drawerLinkMap['комплекти'];
      else if (rawText.indexOf('ново') !== -1) mapData = drawerLinkMap['ново'];
      else if (rawText.indexOf('за нас') !== -1) mapData = drawerLinkMap['за нас'];
      
      if (mapData) {
        if (!childUl.querySelector('.injected-all-link')) {
          var sourceLi = childUl.querySelector('li');
          if (sourceLi) {
            var newLi = sourceLi.cloneNode(true);
            
            // Remove any nested ULs from the clone just in case
            var nestedUls = newLi.querySelectorAll('ul');
            nestedUls.forEach(function(u) { u.remove(); });
            
            var a = newLi.querySelector('a');
            if (a) {
              a.href = mapData.url;
              
              // Only replace text, keeping span/icon structure if present
              var innerSpan = a.querySelector('span');
              if (innerSpan) {
                innerSpan.textContent = mapData.label;
              } else {
                a.textContent = mapData.label;
              }
              
              // Apply native styling and cleaning active states
              a.className = a.className + ' injected-all-link';
              a.className = a.className.replace('menu-drawer__menu-item--active', '');
              a.removeAttribute('aria-current');
              newLi.className = newLi.className.replace('menu-drawer__menu-item--active', '');
              
              a.style.fontWeight = '600';
              a.style.color = '#a88358';
            }
            
            childUl.appendChild(newLi); // Append at the bottom
          }
        }
      }
      li.dataset.injectedAllLinkProcessed = "true";
    });
  }

  // Inject immediately
  document.addEventListener('DOMContentLoaded', injectMobileMenuLinks);
  setTimeout(injectMobileMenuLinks, 1000);

  // Robust observer for late-loading mobile drawers
  var observer = new MutationObserver(function() {
    injectMobileMenuLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Fire on any click as a final safety measure
  document.addEventListener('click', function() {
    setTimeout(injectMobileMenuLinks, 50);
    setTimeout(injectMobileMenuLinks, 300);
  });

  } catch(e) { console.error(e); }
})();
})();
